import { IDeviceNode } from '../../shared/models/device';
import { CardData } from './card-data';

export class SectionCardData extends CardData {
    public isSection = true;
    constructor(_data: IDeviceNode, _name: string, indent?: number, hidableKeys?: string[]) {
        super(_data, _name, null, indent, hidableKeys);
    }
}
